<ul class="menu-options" [ngClass]="{ '!flex-row': isRowMode() }">
  @for (option of menuOptions(); track option.id) {
    <li
      class="menu-options__item {{ option?.optionClasses || '' }}"
      (click)="option?.onSelectOption && option?.onSelectOption(pageLink)">
      @if (option.imgIcon) {
        <img
          [ngSrc]="option.imgIcon"
          [width]="option?.imgWidth || '24'"
          [height]="option?.imgHeight || '24'"
          alt="" />
      } @else {
        <i
          class="iconsax menu-options__icon"
          [attr.icon-name]="option.icon"
          [ngClass]="option?.iconClasses"></i>
      }

      <p class="menu-options__name">
        {{ option.name | translate }}
      </p>
    </li>
  }
</ul>
